import { z } from 'my-zod'

export const OutfitterTypeEnum = z.enum(['Existing', 'Prospective'])
export const OutfitterTypes = OutfitterTypeEnum.Values

export const OutfitterTypeOptions = Object.values(OutfitterTypeEnum.Values)
export type OutfitterType = z.infer<typeof OutfitterTypeEnum>
